// extracted by mini-css-extract-plugin
export default {"list":"gCxskC0W","item":"O4uCTs4F"};